import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import kf1 from "../../Images/KorigadFort/kf1.jpg";
import kf2 from "../../Images/KorigadFort/kf2.jpg";
import kf3 from "../../Images/KorigadFort/kf3.jpg";
import kf4 from "../../Images/KorigadFort/kf4.jpg";
import kf5 from "../../Images/KorigadFort/kf5.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Visapur Fort Trek",
    schedule: [
      { time: "05:45 AM", activity: "Pick-up at Hadapsar." },
      { time: "06:05 AM", activity: "Pick-up at Swargate." },
      { time: "06:25 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "06:40 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "07:05 AM", activity: "Pick-up at Hinjwadi." },
      { time: "08:30 AM", activity: "Breakfast on the way." },
      {
        time: "10:00 AM",
        activity: "Reach the base and begin the trek to Visapur Fort.",
      },
      {
        time: "11:15 AM",
        activity: "Trek through scenic paths and enjoy the cool mountain air.",
      },
      {
        time: "12:30 PM",
        activity:
          "Reach the fort and explore the expansive plateau, walls, and viewpoints.",
      },
      {
        time: "01:30 PM",
        activity: "Lunch break and photography at the fort top.",
      },
      {
        time: "02:30 PM",
        activity: "Descend slowly while soaking in the beautiful surroundings.",
      },
      {
        time: "04:00 PM",
        activity: "Tea break and rest before heading back to Pune.",
      },
      { time: "06:30 PM", activity: "Start the return journey to Pune." },
      { time: "09:00 PM", activity: "Approx. arrival back in Pune." },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Visapur Fort offers one of the most impressive fort panoramas in the Sahyadris, combining history, adventure, and spectacular views.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
      "🏞️ Entry & Local Charges",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Visapur Fort View", image: kf1 },
      { title: "Fort Plateau", image: kf2 },
      { title: "Scenic Trail", image: kf3 },
      { title: "Mountain Panorama", image: kf4 },
      { title: "Historic Fort Walls", image: kf5 },
    ],
    trekData: [
      {
        name: "Visapur Fort Trek",
        image: kf1,
        info: "The Visapur Fort Trek is a thrilling adventure that takes you through a stunning trail to one of the most majestic forts in the Sahyadri range. Known for its huge fort walls, broad plateau, and spectacular views of the valley below, Visapur offers an ideal mix of history and natural beauty. The trek is perfect for those who love fort exploration, photography, and panoramic landscapes, while the peaceful surroundings make the climb even more rewarding.",
      },
    ],
    faq: [
      {
        question: "Why is Visapur Fort popular?",
        answer:
          "It is known for the grand fort structure, large plateau, and amazing views of the surrounding hills and valleys.",
      },
      {
        question: "Is the trek difficult?",
        answer:
          "The trail is moderate with some steep patches, but it is manageable for trekkers with average fitness.",
      },
      {
        question: "What should I carry?",
        answer:
          "Carry a small backpack, water bottle, rain cover, trekking shoes, and a light jacket for windy weather.",
      },
      {
        question: "Are meals included?",
        answer: "Yes, breakfast, lunch, and evening tea are included.",
      },
    ],
  },
];

const VisapurFort = () => {
  return (
    <div className="bg-gray-50 ">
      <Header trekData={data[0].trekData[0]} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <TrekBasicInfo
          trekName="Visapur Fort Trek"
          location="Visapur Fort"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />
        <PackageInclusions />
      </div>
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default VisapurFort;
